import React from 'react';
import './CourseIntro.less';

import EmptyContent from '../empty-content/EmptyContent';
import { htmlTransferGlobal } from '../../../../lib/utils/UtilsCommon';
import Picture from '../../../../components/picture/Picture';
import { dangerHtml, replaceWrapWord } from '../../../../lib/utils/UtilsFormatter';

/**
 * 可选参数
 */
interface IProps {
	type: 'channel' | 'topic'; // 课程类型
	topicInfo?: any;
	topicProfile?: any[];
	channleDesc?: any;
	summary?: any; // 富文本
}
/**
 * CourseIntro
 */
class CourseIntro extends React.Component<IProps, any> {
	private isLoading: boolean = false;

	/**
	 * componentDidUpdate
	 */
	public componentDidUpdate(): void {
		const iframeNode: any = document.getElementById('imIf');
		if (iframeNode && !this.isLoading) {
			this.isLoading = true;
			const src: string = iframeNode.getAttribute('data-src');
			window.onload = (): void => {
				setTimeout((): void => {
					iframeNode.setAttribute('src', src);
				}, 100);
			};
		}
	}

	/**
	 * 专栏渲染
	 */
	get renderChannelIntro(): any {
		const { summary, channleDesc } = this.props;
		let cDesc: any[] = [];

		if (channleDesc && Object.keys(channleDesc).length > 0) {
			cDesc = [
				{
					title: '简介',
					key: 'desc',
				},
				{
					title: '关于讲师',
					key: 'lectuerInfo',
				},
				{
					title: '适合人群',
					key: 'suitable',
				},
				{
					title: '你将获得',
					key: 'gain',
				},
			]
				.map((item: any): any => {
					item.list = channleDesc[item.key] || [];

					return item;
				})
				.filter((item: any): boolean => item.list.length > 0);
		}

		return summary || cDesc.length > 0 ? (
			<div className="p-course-intro channel">
				{summary ? (
					<div className="p-intro-section">
						<p className="p-intro-section-title">简介</p>
						<div className="intro-summary" dangerouslySetInnerHTML={{ __html: summary }}></div>
					</div>
				) : (
					cDesc.map((desc: any, idx: number): any =>
						desc.list.length > 0 ? (
							<div className="p-intro-section" key={idx}>
								<p className="p-intro-section-title">{desc.title}</p>
								<div className="desc-content">
									{desc.list.map((l: any, descIndex: number): any =>
										l.type === 'image' ? (
											<Picture
												className={`desc-image${!desc.list[descIndex - 1] || desc.list[descIndex - 1].type !== 'image' ? ' with-margin' : ''}`}
												src={l.content}
												resize={{
													w: 600,
													m: 'lfit',
													limit: 1,
												}}
											/>
										) : l.type !== 'video' ? (
											<p className="desc-text" key={`desc-item-${descIndex}`} dangerouslySetInnerHTML={dangerHtml(replaceWrapWord(l.content))} />
										) : null
									)}
								</div>
							</div>
						) : null
					)
				)}
			</div>
		) : (
			<EmptyContent />
		);
	}

	/**
	 * 话题渲染
	 */
	get renderTopicIntro(): any {
		const { topicInfo = {}, topicProfile = [], summary } = this.props;

		return summary || topicInfo.speaker || topicInfo.guestIntr || topicProfile.length > 0 ? (
			<div className="p-course-intro topic">
				{topicInfo.speaker ? <pre className="speaker">主讲人：{topicInfo.speaker}</pre> : null}
				{topicInfo.guestIntr ? <pre className="speaker-info">{topicInfo.guestIntr}</pre> : null}

				{summary ? (
					<div className="intro-summary" dangerouslySetInnerHTML={{ __html: summary }}></div>
				) : (
					<>
						{topicInfo.remark ? (
							<pre>
								<code>{htmlTransferGlobal(this.props.topicInfo.remark)}</code>
							</pre>
						) : null}
						{topicProfile && topicProfile.length > 0
							? topicProfile.map((profile: any, idx: number): any => (
									<div className="topic-profile-list">
										{profile.type === 'image' && profile.url ? (
											<Picture
												className="intro-image"
												placeholder
												src={profile.url}
												resize={{
													w: 800,
													m: 'lfit',
													limit: 1,
												}}
											/>
										) : null}
										{profile.msg ? (
											<pre>
												<code>{htmlTransferGlobal(profile.msg)}</code>
											</pre>
										) : null}
									</div>
							  ))
							: null}
					</>
				)}
			</div>
		) : (
			<EmptyContent />
		);
	}

	/**
	 * render
	 */
	public render(): any {
		return this.props.type === 'channel' ? this.renderChannelIntro : this.renderTopicIntro;
	}
}

export default CourseIntro;
